import { render, staticRenderFns } from "./edit_fes.vue?vue&type=template&id=a01384c4&"
import script from "./edit_fes.vue?vue&type=script&lang=js&"
export * from "./edit_fes.vue?vue&type=script&lang=js&"
import style0 from "./edit_fes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports